export default function generateRandomColors(count) {
    const colors = [];

    for (let i = 0; i < count; i++) {
        // const color = {
        //     name: `Color ${i + 1}`,
        let code = `#${Math.floor(Math.random() * 16777215).toString(16)}`
        // };

        colors.push(code);
    }

    return colors;
}